import NavBar from "./Component/NavBar";
import Gallery from "./Component/Gallery";
import ModuleDetail from "./Component/ModuleDetail";
import AdminPage from "./Component/AdminPage";
import "./App.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import { useState, useEffect } from "react";
import { getDistinctModulesBasedOnVisible } from "./utils"

const App = (props) => {
    const {client} = props;
    const [modules, setModules] = useState(null);

    useEffect(() => {
        client.searchModuleMeta().then(
            d => {
                setModules(d.Items);
            }
        ).catch(
            e => console.log(e)
        );
    }, [])

    return (
        <div className="App">
            <NavBar />
            <Router>
                <Switch>
                    <Route 
                        path="/module/:id" 
                        render={(ps) => (
                            <ModuleDetail
                                id = {ps.match.params.id.toString()}
                                client={client}
                                allModules={modules}
                            />
                        )} 
                    />
                    <Route 
                        path="/admin"
                        render={()=> (
                            <AdminPage 
                                client={client}
                            />
                        )}
                    />
                    <Route path='/' 
                        render={(ps) => (
                            <Gallery
                                modules={getDistinctModulesBasedOnVisible(modules)}
                            />
                        )} 
                    />
                </Switch>
            </Router>
        </div>
    );
}

export default App;
